import ContentLoader from "react-content-loader";

const TotalCountLoader = (props: any) => {
  return (
    <>
      <ContentLoader
        style={{ backgroundColor: "#ffffff", borderRadius: "5px" }}
        // viewBox="0 0 0 0"
        height={props.height ? props.height : 20}
        width={props.width ? `${props.width}px` : "25px"}
        {...props}
      >
        <rect width={props.width ?? "50"} height={props.height ?? "20"} />
      </ContentLoader>
    </>
  );
};
export default TotalCountLoader;
